import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable()
export class DateOnlyInterceptor implements HttpInterceptor {

  private dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD
  private isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[\+\-]\d{2}:\d{2})?$/; // ISO 8601

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.responseType === 'blob') {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body) {
          const convertedBody = this.convertDates(event.body);
          return event.clone({ body: convertedBody });
        }
        return event;
      })
    );
  }

  private convertDates(obj: any): any {
    if (obj === null || obj === undefined) return obj;

    // Convert strings that match the DateOnly format
    if (typeof obj === 'string') {
      if (this.dateOnlyRegex.test(obj)) {
        return new Date(obj + 'T00:00:00'); // safe conversion
      }
      if (this.isoDateTimeRegex.test(obj)) {
        return new Date(obj);
      }
    }

    // If it's an array, recurse
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDates(item));
    }

    // If it's an object, recurse through all keys
    if (typeof obj === 'object') {
      const result: any = {};
      for (const key of Object.keys(obj)) {
        result[key] = this.convertDates(obj[key]);
      }
      return result;
    }

    // Primitive value (number, boolean, etc.)
    return obj;
  }
}
